export default __webpack_public_path__ + "static/media/Trash.d66306d8.svg";